import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'

interface CaptionProps {
  children: string
  isFullScreen?: boolean
}

type StyledCaptionProps = Pick<CaptionProps, 'isFullScreen'>

const CaptionText = styled.div<StyledCaptionProps>`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xxsmall: { bundledCSS: xxsmallBodycopyCSS },
        },
      },
      colors: { textDefault, staticWhite },
      utils: { ellipsis },
    },
    isFullScreen,
  }) => css`
    ${xxsmallBodycopyCSS};
    color: ${isFullScreen ? staticWhite : textDefault};
    height: fit-content;

    ${ellipsis('100%', 3)};

    ${desktopCSS(css`
      ${isFullScreen &&
      css`
        color: ${textDefault};
      `}
    `)}
  `}
`

const Caption: FunctionComponent<CaptionProps> = ({
  children,
  isFullScreen,
}) => <CaptionText isFullScreen={isFullScreen}>{children}</CaptionText>

export default Caption
